/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import CompanySettingsPage from './CompanySettingsPage'
import TemplateSettingsPage from './TemplateSettingsPage'

export const settingRoutes: RouteObject[] = [
  {
    path: 'company',
    element: <CompanySettingsPage />
  },
  {
    path: 'templates',
    element: <TemplateSettingsPage />
  }
]
